import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import EngineeringIcon from '@mui/icons-material/Engineering';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { text: 'Αρχική', path: '/' },
    { text: 'Υπηρεσίες', path: '/services' },
    { text: 'Έργα', path: '/projects' },
    { text: 'Σχετικά', path: '/about' },
    { text: 'Επικοινωνία', path: '/contact' },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <List sx={{ bgcolor: 'black', height: '100%' }}>
      {menuItems.map((item) => (
        <ListItem
          button
          component={RouterLink}
          to={item.path}
          key={item.text}
          onClick={handleDrawerToggle}
          sx={{
            color: 'rgb(255, 189, 89)',
            '&:hover': {
              color: 'rgb(255, 205, 121)',
              bgcolor: 'rgba(255, 189, 89, 0.1)',
            },
          }}
        >
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </List>
  );

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          top: 0,
          zIndex: 1100,
          bgcolor: isScrolled ? 'rgba(0, 0, 0, 0.7)' : 'black',
          backdropFilter: isScrolled ? 'blur(10px)' : 'none',
          transition: 'all 0.3s ease',
          boxShadow: isScrolled ? 3 : 0
        }}
      >
        <Toolbar sx={{ 
          minHeight: '64px !important',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              height: isMobile ? '64px' : '64px',
              width: isMobile ? 'auto' : '10%',
              maxWidth: isMobile ? '150px' : 'none',
              overflow: 'hidden',
              padding: 0
            }}
          >
            <img
              src="/images/banner.png"
              alt="Logo"
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'contain',
                display: 'block',
                padding: 0,
                margin: 0
              }}
            />
          </Box>
          {isMobile ? (
            <IconButton
              sx={{ 
                color: 'rgb(255, 189, 89)',
                marginLeft: 'auto'
              }}
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
              {menuItems.map((item) => (
                <Button
                  color="inherit"
                  component={RouterLink}
                  to={item.path}
                  key={item.text}
                  sx={{
                    color: 'rgb(255, 189, 89)',
                    '&:hover': {
                      color: 'rgb(255, 205, 121)',
                    },
                  }}
                >
                  {item.text}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: {
            bgcolor: 'black',
            width: '80%',
            maxWidth: '300px',
          }
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar; 